import { routesMap } from '../../../../../routes/AppRoutes';
import { Reports, DatiMercato } from '../../../../../api/apiTypes';
import { formatTitle } from '../../../../../utils/Format';
import HeroSection from '../../../../conduct-risk/HeroSection';

interface DataFromParent {
  report: Reports | undefined;
  title: string;
  mercato: DatiMercato;
  reportId?: string;
  driverId?: string;
}

const BannerIndiceDiPenetrazionePageDettaglio = ({ report, title, mercato, reportId, driverId }: DataFromParent) => {
  const formattedTitle = formatTitle(title);
  return (
    <HeroSection
      title={mercato.market_name}
      description={formattedTitle}
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: routesMap.VISUALIZZA_REPORT(report?.name ?? ''), title: report?.name ?? '', state: { id: reportId } },
        { url: routesMap.VISUALIZZA_DRIVER(report?.name ?? '', title), title: formattedTitle, state: { id: reportId, driverId } },
        { url: '#', title: mercato.market_name },
      ]}
    />
  );
};

export default BannerIndiceDiPenetrazionePageDettaglio;
